const formTools = {
    setTrapTimer() {
        $('.js_form').find('.js_global__field-time').val(Date.now())
    },

    isNotBot(form) {
        const minTime = 2500
        const endTime = Date.now()
        const startTime = form.find('.js_global__field-time').val()
        if (!startTime) return false
        const diff = endTime - +startTime
        const honeypotValue = form.find('.js_global__field-website').val()
        return diff > minTime && !honeypotValue
    },

    formValidate(form) {
        formTools.clearAllErrors(form)
        let errors = 0
        const formName = form.attr('data-form')
        const objData = new FormData()
        objData.append('subj', formName)
        form.find('.js_form-input').each((i, el) => {
            const wrapper = $(el).closest('.js_form-field')
            const name = $(el).attr('name')
            const type = $(el).attr('type')
            let value = ''
            if (type == 'checkbox') {
                value = $(el).is(':checked') ? 1 : 0
            } else if (type == 'file') {
                value = el.formData ? el.formData : ''
            } else if (typeof $(el).val() == 'string') {
                value = $(el).val() ? $(el).val().trim() : ''
            } else {
                value = $(el).val()
            }
            if (name == 'phone') {
                // const clearValue = value.replace(/[^a-zA-Zа-яА-ЯёЁ0-9]/g, '')
                // if (/^X+$/.test(clearValue)) {
                //     value = ''
                // } else {
                //     value = $(el).attr('data-code') + clearValue
                // }
                value = $(el).val() ? $(el).val().trim().replace(/[^0-9]/g, '') : ''
            }
            if (wrapper.hasClass('required') && name != 'agreement' && !value) {
                errors += formTools.showError(wrapper, 'empty')
            } else {
                if (name == 'email' && !formTools.isValidEmail(value)) {
                    errors += formTools.showError(wrapper, 'invalid')
                // } else if (name == 'phone' && value.includes('X')) {
                //     errors += formTools.showError(wrapper, 'invalid')
                } else if (name == 'agreement' && !$(el).prop('checked')) {
                    errors += formTools.showError(wrapper, 'empty')
                    form.closest('.js_request-form').find('.js_form-global-agreement').addClass('active')
                } else {
                    if (name != 'agreement') {
                        if (type == 'file') {
                            const hasFiles = value instanceof FormData && Array.from(value.keys()).length > 0
                            if (hasFiles) {
                                value.forEach(photo => {
                                    objData.append(name, photo)
                                })
                            } else {
                                objData.append(name, '')
                            }
                        } else {
                            objData.append(name, value)
                        }
                    }
                }
            }
        })
        if (form.find('.js_form-error[data-error=empty].active').length) {
            form.closest('.js_request-form').find('.js_form-global-error').addClass('active')
        }
        if (!errors) {
            formTools.loader(form, true)
            formTools.sendForm(form, objData)
        }
    },

    sendForm(form, objData) {
        $.ajax({
            url: requests.postSend,
            type: 'POST',
            data: objData,
            processData: false,
            contentType: false,
            success: function () {
                formTools.showResult(form, 'success')
            },
            error: function () {
                formTools.showResult(form, 'error')
            }
        })
    },

    loader(form, isStart) {
        if (isStart) {
            form.addClass('loader')
        } else {
            form.removeClass('loader')
        }
    },

    showResult(form, type) {
        formTools.loader(form)
        if (type == 'success') {
            const success = form.find('.js_global__form-result_success')
            const height = form.outerHeight()
            success.siblings().remove()
            success.css('height', height).addClass('active')
        } else if (type == 'error') {
            form.find('.js_global__form-result_error').addClass('active')
        }
    },

    hideErrorResult(btn) {
        btn.closest('.js_global__form-result_error').removeClass('active')
    },

    isValidEmail(value) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(value);
    },

    showError(wrapper, errorType) {
        wrapper.addClass('error')
        wrapper.find(`.js_form-error[data-error=${errorType}]`).addClass('active')
        return 1
    },

    clearError(wrapper) {
        wrapper.removeClass('error')
        wrapper.find('.js_form-error').removeClass('active')
        wrapper.find('.js_form-error[data-remove]').remove()
    },

    clearAllErrors(form) {
        form.find('.js_form-field').removeClass('error')
        form.find('.js_form-error').removeClass('active')
        form.find('.js_form-error[data-remove]').remove()
    },

    clickFiles(inputNode) {
        const input = $(inputNode)
        const wrapper = input.closest('.js_form-field')
        const name = input.attr('name');
        const files = inputNode.files;
        const maxSize = +input.attr('data-max');
        formTools.clearError(wrapper)

        if (!inputNode.formData) {
            inputNode.formData = new FormData();
        }

        for (let file of files) {
            const allowedTypes = ['image/png', 'image/webp', 'image/jpeg', 'image/jpg', 'application/zip', 'application/x-zip-compressed', 'application/pdf']
            const type = file.type
            const size = file.size;
            if (!allowedTypes.includes(type)) {
                continue;
            }
            if (maxSize && size >= maxSize) {
                formTools.showError(wrapper, 'invalid')
                input.closest('.js_request-form').find('.js_form-global-size').addClass('active')
                setTimeout(() => {
                    formTools.clearError(wrapper, 'invalid')
                    input.closest('.js_request-form').find('.js_form-global-size').removeClass('active')
                }, 3000)
                continue;
            }
            inputNode.formData.append(name, file);
        }

        formTools.filesToLoad(inputNode, name);
    },

    filesToLoad(inputNode, name) {
        const wrapper = $(inputNode).closest('.js_form-field').find('.js_form-files')
        wrapper.empty()
        const allFiles = inputNode.formData.getAll(name)
        allFiles.forEach((el, i) => {
            let size = el.size > 1000000 ? parseFloat((el.size / 1000000).toFixed(1)) + ' MB' : Math.ceil(el.size / 1000) + ' KB'
            wrapper.append(`<button class="global__field-loading-file js_global__field-loading-file" type="button" data-id="${i + 1}" ><span class=name>${el.name}</span><span class=size>${size}</span></button>`)
        })
    },

    removeLoadingFile(btn) {
        const id = +btn.attr('data-id')
        const input = btn.closest('.js_form-field').find('input')[0]
        const name = $(input).attr('name')
        const allFiles = input.formData.getAll(name);
        input.formData.delete(name);
        allFiles.forEach((file, i) => {
            if (i + 1 !== id) {
                input.formData.append(name, file);
            }
        });
        formTools.filesToLoad(input, name)
    },

    // createPhoneCodeSelect() {
    //     function getCountries() {
    //         const cached = localStorage.getItem('countries')
    //         if (cached) {
    //             return Promise.resolve(JSON.parse(cached))
    //         }
    //         return fetch('./countries.json')
    //             .then(response => response.json())
    //             .then(countries => {
    //                 localStorage.setItem('countries', JSON.stringify(countries))
    //                 return countries
    //             })
    //     }

    //     function getUserCountryCode() {
    //         const cached = sessionStorage.getItem('userCountryCode')
    //         if (cached) {
    //             return Promise.resolve(cached)
    //         }
    //         return fetch('https://ipapi.co/json/')
    //             .then(response => response.json())
    //             .then(geoData => {
    //                 const userCountryCode = geoData ? geoData.country_code : null
    //                 if (userCountryCode) {
    //                     sessionStorage.setItem('userCountryCode', userCountryCode)
    //                 }
    //                 return userCountryCode
    //             })
    //             .catch(() => null)
    //     }

    //     Promise.all([getCountries(), getUserCountryCode()])
    //         .then(([countries, userCountryCode]) => {
    //             formTools.createCountriesSelect(countries, userCountryCode);
    //         })
    // },

    // createCountriesSelect(countries, userCountryCode) {
    //     const currentCountry = countries.find(country => country.iso === userCountryCode) || countries.find(country => country.iso === "CH")
    //     const container = $(`<div class="global__field-codes"></div>`)
    //     const btn = $(`<button class="global__field-codes-btn" type="button">${currentCountry.iso} ${currentCountry.code}</button>`)
    //     const wrapper = $(`<div class="global__field-codes-wrapper"></div>`)
    //     const search = $(`<input class="global__field-codes-search" type="text" placeholder=${langs.search}>`)
    //     const list = $(`<ul class="global__field-codes-list"></ul>`)
    //     countries.forEach(el => {
    //         const item = $(`<li class="global__field-codes-item" data-mask="${el.mask}" data-code="${el.code}"><img src="${el.flag}">${el.iso} ${el.code}</li>`)
    //         list.append(item)
    //     })
    //     container.append(btn)
    //     container.append(wrapper)
    //     wrapper.append(search)
    //     wrapper.append(list)

    //     $('.js_form-input_phone-label').each((i, el) => {
    //         $(el).after(container)
    //         const input = $(el).siblings('.js_form-input_phone')
    //         input.attr('data-code', currentCountry.code)
    //         formTools.setMask(input[0], currentCountry.mask)
    //     })
    // },

    // togglePhoneCodeSelect(btn) {
    //     const wrapper = btn.closest('.global__field-codes')
    //     if (wrapper.hasClass('active')) {
    //         formTools.closePhoneCodeSelect(wrapper)
    //     } else {
    //         wrapper.addClass('active')
    //     }
    // },

    // closePhoneCodeSelect(wrapper) {
    //     wrapper.find('.global__field-codes-search').val('')
    //     wrapper.find('.global__field-codes-item').removeClass('hide')
    //     wrapper.removeClass('active')
    // },

    // searchPhoneCodeSelect(input) {
    //     const value = input.val().toUpperCase()
    //     const list = input.next('.global__field-codes-list')
    //     list.find('.global__field-codes-item').each((i, el) => {
    //         const text = $(el).text()
    //         if (value == '') {
    //             $(el).removeClass('hide')
    //         } else {
    //             !text.includes(value) ? $(el).addClass('hide') : $(el).removeClass('hide')
    //         }
    //     })
    // },

    // choosePhoneCodeSelect(item) {
    //     const wrapper = item.closest('.global__field-codes')
    //     const input = wrapper.next('.js_form-input_phone')
    //     const btn = wrapper.find('.global__field-codes-btn')
    //     btn.text(item.text())
    //     input.attr('data-code', item.attr('data-code'))
    //     if (input[0].mask) {
    //         input.val('')
    //         input[0].mask.destroy()
    //         formTools.setMask(input[0], item.attr('data-mask'))
    //     }
    // },

    // setMask(input, mask) {
    //     input.mask = IMask(input, {
    //         mask: mask,
    //         lazy: false,
    //         placeholderChar: 'X',
    //     })
    // },

    phoneInput(input) {
        if (input.attr('name') == 'phone') {
            const value = input.val()
            const regEx = /[^0-9 \-+()]/g
            input.val(value.replace(regEx, ''))
        }
    },

    messageInput(textarea) {
        textarea.attr('rows', 1)
        const wrapper = textarea.closest('.js_form-field')
        const value = textarea.val()
        const length = value.length
        if (length > 582) {
            textarea.val(value.slice(0, 582))
            formTools.showError(wrapper, 'invalid')
            textarea.closest('.js_request-form').find('.js_form-global-message').addClass('active')
        } else {
            textarea.closest('.js_request-form').find('.js_form-global-message').removeClass('active')
        }
        const height = textarea[0].scrollHeight
        const lineHeight = parseInt(textarea.css('lineHeight')) || 20
        const lines = Math.ceil(height / lineHeight)
        textarea.attr('rows', lines)
    },


    hidePhoneLabel(label) {
        label.addClass('hide')
    },

    showPhoneLabel(target) {
        const isInput = target.hasClass('js_form-input_phone')
        const isLabel = target.hasClass('js_form-input_phone-label')
        const isCode = target.closest('.global__field-codes').length
        if (!isLabel && !isCode && !isInput) {
            $('.js_form-input_phone').each((i, el) => {
                const clearValue = $(el).val().replace(/[^a-zA-Zа-яА-ЯёЁ0-9]/g, '')
                if (/X/.test(clearValue)) {
                    $(el).siblings('.js_form-input_phone-label').removeClass('hide')
                    if (el.mask) {
                        $(el).val('')
                        const mask = el.mask.masked.mask
                        el.mask.destroy()
                        formTools.setMask(el, mask)
                    }
                }
            })
        }
    }
}

$(document).ready(() => {
    // formTools.createPhoneCodeSelect()
    formTools.setTrapTimer()
})

$(document).on('click', '.js_form-input_phone-label', function () {
    formTools.hidePhoneLabel($(this))
})

$(document).on('click', '.js_form-input_phone-label', function(e) {
    e.preventDefault()
    $(this).siblings('.js_form-input_phone').focus()
})

$(document).on('submit', '.js_form', function (e) {
    e.preventDefault()
    if (formTools.isNotBot($(this))) {
        formTools.formValidate($(this))
    }
})

$(document).on('change', '.js_form-files-add', function (e) {
    e.preventDefault()
    formTools.clickFiles(this)
})

$(document).on('click', '.js_form-files-remove', function () {
    formTools.removeLoadingFile($(this))
})

$(document).on('click', '.js_global__field-loading-file', function () {
    formTools.removeLoadingFile($(this))
})

$(document).on('input', '.js_form-input', function () {
    $(this).closest('.js_request-form').find('.js_form-global-error').removeClass('active')
    const wrapper = $(this).closest('.js_form-field')
    formTools.clearError(wrapper)
    if ($(this).hasClass('js_form-input_message')) {
        formTools.messageInput($(this))
    }
    formTools.phoneInput($(this))
})

$(document).on('change', 'select.js_form-input', function () {
    const wrapper = $(this).closest('.js_form-field')
    formTools.clearError(wrapper)
    if ($(this).prop('checked')) {
        $(this).closest('.js_request-form').find('.js_form-global-agreement').removeClass('active')
    }
})

$(document).on('click', '.global__field-codes-btn', function () {
    formTools.togglePhoneCodeSelect($(this))
})

$(document).on('click', function (e) {
    if (!$(e.target).closest('.global__field-codes').length) {
        $('.global__field-codes').each((i, el) => { formTools.closePhoneCodeSelect($(el)) })
    }
    formTools.showPhoneLabel($(e.target))
})

$(document).on('input', '.global__field-codes-search', function () {
    formTools.searchPhoneCodeSelect($(this))
})

$(document).on('click', '.global__field-codes-item', function () {
    formTools.choosePhoneCodeSelect($(this))
})

$(document).on('click', '.js_global__form-again', function () {
    formTools.hideErrorResult($(this))
})